import { ErrorBoundary } from 'components/common/error-boundary';
import { FlexTableWrapper } from 'components/common/layout/flex-table-wrapper';
import { AnalyticsHeader } from 'components/sections/analytics/header';
import { SessionsTable } from 'components/sections/analytics/session-history/table';
import { SessionEventsContext } from 'contexts/session-events.context';
import { SessionDialogMode } from 'enums/session.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useContext, useEffect } from 'react';
import { useAuthStore } from 'stores/use-auth-store';

export const SessionHistory = () => {
  const { showDialog, fetchSessions, reset } = useContext(SessionEventsContext);
  const current = useAuthStore((s) => s.current);

  /** load data to match session access */
  useEffect(() => {
    fetchSessions();

    return () => {
      reset();
    };
  }, [current.auth, current.session]);

  return (
    <ErrorBoundary identifier="SessionHistory">
      <FlexTableWrapper
        gap={RADIX.FLEX.GAP.SECTION}
        header={
          <AnalyticsHeader
            actions={[
              {
                label: 'main.current-session',
                onClick: () =>
                  showDialog({
                    session: {
                      sessionID: current.session,
                    },
                    mode: SessionDialogMode.edit,
                    key: Date.now(),
                  }),
              },
            ]}
          />
        }
        table={<SessionsTable />}
      />
    </ErrorBoundary>
  );
};
